import { SVGProps } from "react";

const RemoveCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={60}
    height={60}
    viewBox="0 0 60 60"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx={30} cy={30} r={30} fill="#FFF6F4" />
    <path
      d="M29.8984 42.5C36.7734 42.5 42.3984 36.875 42.3984 30C42.3984 23.125 36.7734 17.5 29.8984 17.5C23.0234 17.5 17.3984 23.125 17.3984 30C17.3984 36.875 23.0234 42.5 29.8984 42.5Z"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M24.8984 30H34.8984"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default RemoveCircle;
